// Erro causado por backend fora do ar ou rede caída (deploy, restart, queda),
// não por algo que o usuário fez: sem resposta do servidor ou gateway sem
// backend atrás (502/503/504). Esses erros não são mostrados — só a sidebar
// indica "Conexão perdida".
const GATEWAY_STATUSES = [502, 503, 504];

const isConnectivityError = (err) => {
  if (!err || typeof err !== "object") return false;
  if (!err.isAxiosError && !err.config) return false;
  // Requisição cancelada pelo próprio app (AbortController) não é queda
  if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return false;
  if (!err.response) return true;
  return GATEWAY_STATUSES.includes(err.response.status);
};

export default isConnectivityError;
